export enum DateRange {
    Day = 'Day',
    Week = 'Week',
    Month = 'Month',
    Year = 'Year'
}
